/* eslint-disable react/no-direct-mutation-state */
/* eslint-disable no-unused-vars */
import { LinearProgress } from "@material-ui/core";
import axios from "axios";
import React, { Component } from "react";
import { Button, ButtonToolbar, Table } from "react-bootstrap";
import { Link } from "react-router-dom";
import AppConfig from "../../../../config/AppConfig";

class Detail extends Component {
  constructor(props, context) {
    super(props, context);
  }
  state = {
    loadingList: true,
    listDetailLembaga: [],
  };

  componentDidMount() {
    this.setState({ loadingList: true });
    let userdata = JSON.parse(localStorage.getItem("sessiondata"));
    // console.log(userdata);

    const url = window.location.pathname;
    var id = url.substring(url.lastIndexOf("/") + 1);
    axios
      .post(AppConfig.ListDetailRekapitulasi + id + "?id_bp=" + userdata.i_idbp)
      .then((res) => {
        this.setState({
          loadingList: false,
          listDetailLembaga: res.data.result.data,
        });
      })
      .catch((err) => {
        console.log(err);
      });
  }

  exportExcel = () => {
    let list_data = this.state.listDetailLembaga;
    var title = "<h3>Rekap Pelaporan SPMI Berdasarkan Perguruan Tinggi</h3>";
    var tab_text =
      title +
      "<table border='2'><thead><tr><th rowspan='2'>No</th><th rowSpan='2'>Perguruan Tinggi</th><th colspan='2'>Pengaturan Standar</th><th colspan='2'>Evaluasi</th><th colspan='2'>Pengendalian</th><th colspan='2'>Peningkatan</th></tr><tr><th>Pengaturan Terisi</th><th>Pengaturan Terverifikasi</th><th>Evaluasi Terisi</th><th>Evaluasi Terverifikasi</th><th>Pengendalian Terisi</th><th>Pengendalian Terverifikasi</th><th>Peningkatan Terisi</th><th>Peningkatan Terverifikasi</th></tr></thead><tbody>";
    var row = "";
    list_data.map((list, i) => {
      var no = i + 1;
      row += "<tr>";
      row += "<td align='center'>" + no + "</td>";
      row += "<td align='left'>" + list.nm_lemb + "</td>";
      row += "<td align='center'>" + list.pengaturan + "</td>";
      row += "<td align='center'>" + list.pengaturan_terverif + "</td>";
      row += "<td align='center'>" + list.evaluasi + "</td>";
      row += "<td align='center'>" + list.evaluasi_terverif + "</td>";
      row += "<td align='center'>" + list.pengendalian + "</td>";
      row += "<td align='center'>" + list.pengendalian_terverifikasi + "</td>";
      row += "<td align='center'>" + list.peningkatan + "</td>";
      row += "<td align='center'>" + list.peningkatan_terverif + "</td>";
      row += "</tr>";
    });

    tab_text = tab_text + row + "</tbody></table>";

    tab_text = tab_text.replace(/<A[^>]*>|<\/A>/g, "");
    tab_text = tab_text.replace(/<img[^>]*>/gi, "");
    tab_text = tab_text.replace(/<input[^>]*>|<\/input>/gi, "");

    var link = window.document.createElement("a");

    link.setAttribute(
      "href",
      "data:text/xls;charset=utf-8,%EF%BB%BF" + encodeURIComponent(tab_text)
    );
    link.setAttribute(
      "download",
      "rekap_pelaporan_spmi_berdasarkan_perguruan_tinggi.xls"
    );
    link.click();
    return false;
  };

  render() {
    let userdata = JSON.parse(localStorage.getItem("sessiondata"));

    let i = 0;
    let list_result = [];
    if (this.state.listDetailLembaga !== undefined) {
      for (var key in this.state.listDetailLembaga) {
        list_result[i] = {
          result: this.state.listDetailLembaga[key],
        };
        i++;
      }
    }

    return (
      <>
        {this.state.loadingList === false ? (
          <div className="row" style={{ marginBottom: "20px" }}>
            <div className="col-md-6">
              <div style={{ float: "left" }}>
                <ButtonToolbar>
                  <span className="svg-icon svg-icon-2x svg-icon-white">
                    <Button variant="success" onClick={this.exportExcel}>
                      <i
                        className="flaticon-download"
                        style={{ color: "#ffffff", fontSize: "14px" }}
                      ></i>
                      &nbsp; Export Excel
                    </Button>
                  </span>
                </ButtonToolbar>
              </div>
            </div>
            <div className="col-md-6">
              <div style={{ float: "right" }}>
                <ButtonToolbar>
                  <span className="svg-icon svg-icon-2x svg-icon-white">
                    <Link to="/rekapitulasi">
                      <Button variant="secondary">Kembali</Button>
                    </Link>
                  </span>
                </ButtonToolbar>
              </div>
            </div>
          </div>
        ) : (
          <></>
        )}
        <Table responsive hover style={{ overflow: "auto" }}>
          <thead className="text-white" style={{ backgroundColor: "#3047ad" }}>
            <tr>
              <th
                rowSpan="2"
                style={{
                  verticalAlign: "middle",
                  textAlign: "center",
                }}
              >
                No
              </th>
              <th
                rowSpan="2"
                style={{
                  verticalAlign: "middle",
                  textAlign: "center",
                }}
              >
                Perguruan Tinggi
              </th>
              <th
                colSpan="2"
                style={{
                  verticalAlign: "middle",
                  textAlign: "center",
                }}
              >
                Pengaturan Standar
              </th>
              <th
                colSpan="2"
                style={{
                  verticalAlign: "middle",
                  textAlign: "center",
                }}
              >
                Evaluasi
              </th>
              <th
                colSpan="2"
                style={{
                  verticalAlign: "middle",
                  textAlign: "center",
                }}
              >
                Pengendalian
              </th>
              <th
                colSpan="2"
                style={{
                  verticalAlign: "middle",
                  textAlign: "center",
                }}
              >
                Peningkatan
              </th>
            </tr>
            <tr>
              <th
                style={{
                  verticalAlign: "middle",
                  textAlign: "center",
                }}
              >
                Pengaturan Terisi
              </th>
              <th
                style={{
                  verticalAlign: "middle",
                  textAlign: "center",
                }}
              >
                Pengaturan Terverifikasi
              </th>
              <th
                style={{
                  verticalAlign: "middle",
                  textAlign: "center",
                }}
              >
                Evaluasi Terisi
              </th>
              <th
                style={{
                  verticalAlign: "middle",
                  textAlign: "center",
                }}
              >
                Evaluasi Terverifikasi
              </th>
              <th
                style={{
                  verticalAlign: "middle",
                  textAlign: "center",
                }}
              >
                Pengendalian Terisi
              </th>
              <th
                style={{
                  verticalAlign: "middle",
                  textAlign: "center",
                }}
              >
                Pengendalian Terverifikasi
              </th>
              <th
                style={{
                  verticalAlign: "middle",
                  textAlign: "center",
                }}
              >
                Peningkatan Terisi
              </th>
              <th
                style={{
                  verticalAlign: "middle",
                  textAlign: "center",
                }}
              >
                Peningkatan Terverifikasi
              </th>
            </tr>
          </thead>
          <tbody>
            {this.state.loadingList === true ? (
              <tr>
                <td colSpan="10">
                  <LinearProgress color="secondary" variant="query" />
                </td>
              </tr>
            ) : list_result.length > 0 ? (
              list_result.map((list, i) => (
                <tr>
                  <td style={{ verticalAlign: "middle", textAlign: "center" }}>
                    {i + 1}
                  </td>
                  <td style={{ verticalAlign: "middle" }}>
                    {list.result.nm_lemb}
                  </td>
                  <td style={{ verticalAlign: "middle", textAlign: "center" }}>
                    {list.result.pengaturan}
                  </td>
                  <td style={{ verticalAlign: "middle", textAlign: "center" }}>
                    {list.result.pengaturan_terverif}
                  </td>
                  <td style={{ verticalAlign: "middle", textAlign: "center" }}>
                    {list.result.evaluasi}
                  </td>
                  <td style={{ verticalAlign: "middle", textAlign: "center" }}>
                    {list.result.evaluasi_terverif}
                  </td>
                  <td style={{ verticalAlign: "middle", textAlign: "center" }}>
                    {list.result.pengendalian}
                  </td>
                  <td style={{ verticalAlign: "middle", textAlign: "center" }}>
                    {list.result.pengendalian_terverifikasi}
                  </td>
                  <td style={{ verticalAlign: "middle", textAlign: "center" }}>
                    {list.result.peningkatan}
                  </td>
                  <td style={{ verticalAlign: "middle", textAlign: "center" }}>
                    {list.result.peningkatan_terverif}
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="3" style={{ textAlign: "center" }}>
                  <em>Data does not exist</em>
                </td>
              </tr>
            )}
          </tbody>
        </Table>
      </>
    );
  }
}
export default Detail;
